import { EndpointBuilder } from '@reduxjs/toolkit/query';
import {
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from '@reduxjs/toolkit/query';
import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { NFMSFailedLogsResponse, NFMSSuccessLogsResponse } from '../../types';
import { NFMSFilter } from '../../types/records/feeder-master-data';

export const nfmsLogsEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    'nfmsApi'
  >
) => ({
  getNFMSSuccessLogs: builder.mutation<NFMSSuccessLogsResponse, NFMSFilter>({
    query: (data) => ({
      url: `success_request_response_logs/`,
      method: 'POST',
      body: data
    })
  }),
  getNFMSFailedLogs: builder.mutation<NFMSFailedLogsResponse, NFMSFilter>({
    query: (data) => ({
      url: `failed_request_response_logs/`,
      method: 'POST',
      body: data
    })
  })
});
